import Image, { ImageProps } from "next/image";
import { useEffect, useState } from "react";
import { useRemoteConfig } from "../hooks/config";

// Images from arweave are sometimes cached by Vercel before they're properly propagated.
// Vercel seems to ignore '_vercel_no_cache=1' added to the image url, despite its docs.
// Vercel also seems to break all images if 'unoptimized: true' is added to next.config, despite Vercel docs.

interface ArweaveImageProps extends ImageProps {
  optimize?: Boolean;
}

export const ArweaveImage = ({
  optimize = true,
  ...args
}: ArweaveImageProps) => {
  const [imageUrl, setImageUrl] = useState<string>(args.src as string);
  const configContext = useRemoteConfig();
  const cacheBuster = configContext.getValue("vercel_cache_buster");

  useEffect(() => {
    if (!configContext.isLoading) {
      setImageUrl(`${args.src}?cache_bust=${cacheBuster}`);
    }
  }, [configContext, cacheBuster]);

  if (!imageUrl) {
    return null;
  } else {
    return (
      <Image
        placeholder={"empty"}
        {...args}
        unoptimized={!optimize}
        src={imageUrl}
      />
    );
  }
};
